import {
  Box,
  Card,
  CircularProgress,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CachedIcon from "@mui/icons-material/Cached";
import TrackChangesSharpIcon from "@mui/icons-material/TrackChangesSharp";
import { totalUsersAction } from "../../redux/toolkit/dashbaord/totalUsers";

export default function TotalUser() {
  // state
  const dispatch = useDispatch();
  const totalUsersSelector = useSelector((state) => state.totalUsers);
  const { data, loading } = totalUsersSelector;

  // fn
  const handleRefeash = () => {
    dispatch(totalUsersAction());
  };

  // use effect
  useEffect(() => {
    dispatch(totalUsersAction());
  }, [dispatch]);

  return (
    <Card sx={{ p: 2, color: "#0C6A96" }}>
      <Stack direction="row" justifyContent="space-between">
        <TrackChangesSharpIcon color="#0C6A96" />
        <Typography
          sx={{
            color: "#5E6C8A",
            fontFamily: "Montserrat,sans-serif",
            fontStyle: "normal",
          }}
          variant="subtitle2"
        >
          Total Users
        </Typography>
        <IconButton sx={{ color: "#5E6C8A" }} onClick={handleRefeash}>
          <CachedIcon />
        </IconButton>
      </Stack>

      {loading ? (
        <CircularProgress />
      ) : (
        <Box>
          <Typography
            variant="h3"
            color="primary"
            sx={{ fontWeight: 600, color: "#071D45" }}
          >
            {data?.userDataCount ? data?.userDataCount : "---"}
          </Typography>
        </Box>
      )}
    </Card>
  );
}
